module.exports = __webpack_public_path__ + "img/41.13c2d3f8.jpg";